import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRangeValue, TAdditionalServicesValue, TRoomsValue } from '../../types/quiz';
import { EFormStep, IRequestFormV2 } from '../../types/requestForm/requestFormV2';

const initialState: IRequestFormV2 = {
  step: EFormStep.Rooms,
  meta: {
    showRequestForm: false,
    requiresAuth: false,
  },
  quiz: {
    roomCount: null,
    priceRange: null,
    additionalServices: null,
  },
};

export const requestFormV2Slice = createSlice({
  name: 'requestFormV2',
  initialState,
  reducers: {
    setFormStep: (state, action: PayloadAction<EFormStep>) => {
      state.step = action.payload;
    },
    setRoomCount: (state, action: PayloadAction<TRoomsValue[]>) => {
      state.quiz.roomCount = action.payload;
    },
    setPriceRange: (state, action: PayloadAction<IRangeValue>) => {
      state.quiz.priceRange = action.payload;
    },
    setAdditionalServices: (state, action: PayloadAction<TAdditionalServicesValue>) => {
      state.quiz.additionalServices = action.payload;
    },
    resetForm: state => {
      state.step = EFormStep.Rooms;
      state.quiz.roomCount = null;
      state.quiz.priceRange = null;
      state.quiz.additionalServices = null;
    },
  },
});

export const {
  reducer: requestFormV2Reducer,
  actions: { setFormStep, setRoomCount, setPriceRange, setAdditionalServices, resetForm },
} = requestFormV2Slice;
